/**
 * Unified Video Loader
 *
 * Routes all storefront video proxying through Cloudflare.
 */

import { getCdnBaseUrl } from '@/lib/cdn/config';

export type VideoQuality = 'best' | 'good' | 'eco';

/**
 * Unified video loader that routes through Cloudflare.
 * `quality` is read by the Cloudflare image proxy snippet and mapped to Cloudinary `q_auto:<quality>`.
 */
export const videoLoader = (src: string, quality?: VideoQuality): string => {
  if (!src || !src.startsWith('https')) return src;

  const baseUrl = getCdnBaseUrl('cloudflare');
  const proxiedUrl = `${baseUrl}/api/image-proxy/${src.replace(
    'https://',
    '',
  )}`;

  if (!quality) return proxiedUrl;

  return `${proxiedUrl}${proxiedUrl.includes('?') ? '&' : '?'}q=${quality}`;
};
